"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.searchArrayOfObjects = exports.searchArray = exports.searchText = void 0;
const searchText = (search = '', text = '') => {
    // Keep only letters, numbers, and spaces
    const normalize = (str) => str
        .toLowerCase()
        .replace(/[^a-z0-9\s]/gi, ' ')
        .replace(/\s+/g, ' ')
        .trim();
    const normalizedText = normalize(text);
    const words = normalize(search)
        .split(' ')
        .filter(Boolean);
    return words.every((word) => normalizedText.includes(word));
};
exports.searchText = searchText;
// Search ARRAY of STRINGS
const searchArray = (search, array = []) => array.filter((val) => {
    // Handle `Object.entries` or Array< Array<*> >
    if (Array.isArray(val)) {
        const match = val.filter((subVal) => (0, exports.searchText)(search, subVal)) || [];
        return !!match.length;
    }
    else {
        return (0, exports.searchText)(search, val);
    }
});
exports.searchArray = searchArray;
// Search ARRAY of OBJECT and check ATTRIBUTES
const searchArrayOfObjects = (search, array = [], attrs = []) => array.filter((obj) => {
    let match = false;
    attrs.forEach((attr) => {
        if ((0, exports.searchText)(search, obj[attr])) {
            match = true;
        }
    });
    return match;
});
exports.searchArrayOfObjects = searchArrayOfObjects;
